import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-04a54770"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "wrap"
};
var _hoisted_2 = {
  class: "inner"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("全国青少年软件编程等级考试");

var _hoisted_4 = {
  class: "module"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "sub-text"
  }, " 全国青少年软件编程等级考试由中国电子学会主办，是首个全国级面向青少年软件编程能力水平的社会化评价项目，旨在推动我国基础教育与高等教育软件类人才培养与评价的衔接，培养青少年的逻辑思维能力和实践创新能力。 ", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "details"
  }, "200000+", -1);
});

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "unit"
  }, "名青少年", -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "details"
  }, "25", -1);
});

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "unit"
  }, "个省市", -1);
});

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "details"
  }, "600", -1);
});

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "unit"
  }, "家考点", -1);
});

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "sub-text"
  }, " 是迄今为止具有大量实践积累且规模最大的等级考试，截至目前已有超过20万名青少年参加，覆盖全国超过25个省市逾600家考点。 ", -1);
});

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "weight-text"
  }, " 中国电子学会是工业和信息化部的直属事业单位，中国科学技术协会重要组成部分，人社部5A级全国学术类社会团体，人力资源和社会保障部国家专业技术人员继续教育基地。 ", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ModuleTitle = _resolveComponent("ModuleTitle");

  var _component_a_col = _resolveComponent("a-col");

  var _component_a_row = _resolveComponent("a-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_ModuleTitle, {
    class: "module-title"
  }, {
    default: _withCtx(function () {
      return [_hoisted_3];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_row, {
    class: "col-content text-center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_hoisted_6, _hoisted_7];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_hoisted_8, _hoisted_9];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_hoisted_10, _hoisted_11];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _hoisted_12, _hoisted_13])])]);
}